// extracted by mini-css-extract-plugin
export default {"myCampaignsAction":"RouteTitle_myCampaignsAction__IQkxF","actionLabel":"RouteTitle_actionLabel__rlWWK"};